import { __rest } from "tslib";
import React, { useEffect } from 'react';
import cn from 'classnames';
import { IconButton } from "../CTA";
import Button from "../CTA/Button";
import ParcelCancelledIcon from "../Icon/HmIcons/ParcelCancelledIcon";
import ParcelIcon from "../Icon/HmIcons/ParcelIcon";
import { CheckboxOutlinedIcon, CloseIcon, HazmatWarningIcon, InfoIcon, WarningIcon, PinOutlineIcon, } from '../Icon';
import BodyText from '../Typography/texts/BodyText';
import MetaText from '../Typography/texts/MetaText';
import styles from './StatusMessage.module.scss';
export const icons = {
    info: InfoIcon,
    warning: InfoIcon,
    checkbox: CheckboxOutlinedIcon,
    error: WarningIcon,
    hazmatWarning: HazmatWarningIcon,
    parcel: ParcelIcon,
    parcelCancelled: ParcelCancelledIcon,
    pin: PinOutlineIcon,
};
const StatusMessage = (_a) => {
    var { className, iconPosition = 'start', type, markup, message, icon, onCtaClick, buttonPosition = 'start', isCtaBtnDisabled, isSmallHazmatTextEnabled = false, ctaContent, hasCloseButton, closeButtonLabel, onCloseButtonClick, onRender, onAfterRender, isBodyTextMetaEnabled = false } = _a, props = __rest(_a, ["className", "iconPosition", "type", "markup", "message", "icon", "onCtaClick", "buttonPosition", "isCtaBtnDisabled", "isSmallHazmatTextEnabled", "ctaContent", "hasCloseButton", "closeButtonLabel", "onCloseButtonClick", "onRender", "onAfterRender", "isBodyTextMetaEnabled"]);
    useEffect(() => {
        if (typeof onRender === 'function') {
            onRender();
        }
        if (typeof (onAfterRender === null || onAfterRender === void 0 ? void 0 : onAfterRender.callback) === 'function') {
            setTimeout(() => {
                onAfterRender.callback();
            }, onAfterRender.timeout);
        }
    }, []);
    if (!message) {
        return null;
    }
    const IconComp = (icon && icons[icon]) || icons.info;
    return (React.createElement("div", Object.assign({ role: "status", className: cn(styles.container, className, type === 'info' && styles.info, type === 'valid' && styles.valid, type === 'invalid' && styles.invalid, type === 'warning' && styles.warning, type === 'transparent' && styles.transparent) }, props),
        icon && iconPosition === 'start' && (React.createElement(IconComp, { className: styles.iconBeforeText, "data-testid": "iconBeforeText" })),
        isSmallHazmatTextEnabled ? (React.createElement(MetaText, { Tag: message ? 'div' : 'p', className: styles.text }, message)) : (React.createElement(BodyText, { meta: isBodyTextMetaEnabled, Tag: message ? 'div' : 'p', className: cn(styles.text) }, message)),
        icon && iconPosition === 'end' && (React.createElement(IconComp, { className: styles.iconAfterText, "data-testid": "iconAfterText" })),
        buttonPosition === 'end' && (React.createElement(Button, { disabled: isCtaBtnDisabled, secondary: true, size: "small", onClick: onCtaClick }, ctaContent)),
        hasCloseButton && (React.createElement(IconButton, { className: styles.closeButton, onClick: onCloseButtonClick, iconElement: React.createElement(CloseIcon, { size: "small" }) }, closeButtonLabel))));
};
export default StatusMessage;
//# sourceMappingURL=StatusMessage.js.map